import { render, staticRenderFns } from "./StrOkasKodlari.vue?vue&type=template&id=4d0effd2"
import script from "./StrOkasKodlari.vue?vue&type=script&lang=js"
export * from "./StrOkasKodlari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports